import { render, staticRenderFns } from "./AddSubmission.vue?vue&type=template&id=f616f8f4&"
import script from "./AddSubmission.vue?vue&type=script&lang=js&"
export * from "./AddSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports